import { Component, OnInit } from '@angular/core';
import { Licitacao } from '../../_classes/licitacao';
import { Arquivo } from '../../_classes/arquivo';
import { LicitacaoFilter } from '../../_classes/licitacaoFilter';
import { Router, ActivatedRoute } from '@angular/router';

import { MODALIDADES } from '../../_mocks/modalidades';
import { COMISSOES } from '../../_mocks/comissoes';
import { ORGAOS } from '../../_mocks/orgaos';
import { TIPO_DE_DOCUMENTOS } from '../../_mocks/tipoDeDocumentos';
import { FASES_DA_LICITACAO } from '../../_mocks/fasesDaLicitacao';
import { TIPOS_DE_OBJETO_DA_LICITACAO } from '../../_mocks/tiposDeObjetoDaLicitacao';
import { Base64Service } from '../../services/base64.service';

import { saveAs } from 'file-saver/FileSaver';
import { LoadingService } from '../../services/loading.service';
import { LicitacaoService } from '../../services/licitacao.service';

import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { UserSessionService } from '../../services/user-session.service';
import { URL } from '../../_mocks/url';
import { BehaviorSubject } from 'rxjs';
import { ConfiguracaoPaginacao } from '../paginacao/configuracaoPaginacao';
import { DadosPaginacao } from '../paginacao/dadosPaginacao';
import mergeObjects from '../../util/objectHandler';
import {DialogComponent} from "../dialog/dialog.component";
import {MatDialog} from "@angular/material/dialog";


@Component({
  selector: 'app-licitacao-list-simple',
  templateUrl: './licitacao-list-simple.component.html',
  styleUrls: ['./licitacao-list-simple.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ]
})
export class LicitacaoListSimpleComponent implements OnInit {

  isUserSession: boolean;
  filter = '';
  order = '';
  orderDataSaved = false;
  public maskLicitacao = [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskData = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public mascaraCnpj = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,];
  licitacoes: Licitacao[];
  arquivos: Arquivo[];
  modalidades = MODALIDADES;
  comissoes = COMISSOES;
  orgaos = ORGAOS;
  tipoDeDocumentos = TIPO_DE_DOCUMENTOS;
  fasesDaLicitacao = FASES_DA_LICITACAO;
  tiposDeObjetoDaLicitacao = TIPOS_DE_OBJETO_DA_LICITACAO;
  licitacaoFilter = new LicitacaoFilter();
  queryParams = null;

  /**
   * Paginacao
   */
  ultimoDadoPaginacao: DadosPaginacao;
  subjectPaginacao: BehaviorSubject<ConfiguracaoPaginacao> = new BehaviorSubject<ConfiguracaoPaginacao>(undefined);

  constructor(
    private adapter: DateAdapter<any>,
    private licitacaoService: LicitacaoService,
    private base64Service: Base64Service,
    private loadingService: LoadingService,
    private userSession: UserSessionService,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.getLicitacoesByFilter(false);
    this.getUserSession();
    this.listenToQueryParams();
  }

  /**
   * Metodo de onde query params devem ser buscados
   */
  listenToQueryParams() {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
      this.changeFiltro(params);
    });
  }

  /**
   * Bloqueia os campos que já foram definidos via query params
   * @param inputId Id do input que está sendo verificado se irá ser bloqueado ou nao, este Id deve corresponder
   *   ao queryparam
   */
  bloquearAtributosPreDefinidos(inputId) {
    console.log(inputId);
   return Object.keys(this.queryParams).find(param => { return param === inputId}) != undefined;
  }

  /**
   * Carrega automaticamente os filtros passados via query param
   */
  changeFiltro(filtroToApply) {

    const getFieldFormatter = (paramName) => {
      const specialFieldsFormatterMap = {
        isCovid19: value => !!value
      }
      const specialFormatter = specialFieldsFormatterMap[paramName];

      return specialFormatter ? specialFormatter : (value) => value;
    }

    mergeObjects(filtroToApply, this.licitacaoFilter, getFieldFormatter);
    console.log('changeFiltro', filtroToApply, this.licitacaoFilter);
    this.getLicitacoesByFilter(false);
  }

  getLicitacoes() {
    this.licitacaoService.getLicitacoes().subscribe(licitacoes => {
      this.licitacoes = licitacoes;
      this.formatarCNPJNumeroContrato();
    });
  }

  formatarCNPJNumeroContrato() {
    this.licitacoes.forEach(licitacao => {
      licitacao.identificador = licitacao.identificador ? licitacao.identificador.toString().replace(/\,/g, ', ') : ''
      licitacao.numeroContrato = licitacao.numeroContrato.toString().replace(/\,/g, ', ')
    })
  }

  getUserSession() {
    this.userSession.isUserSession.subscribe(user => {
      this.isUserSession = user;
    });
  }

  loadFiles(id: number) {
    this.arquivos = [];
    this.loadingService.changeLoading(true);
    this.licitacaoService.getArquivosDaLicitacao(id).subscribe(arquivos => {
      this.loadingService.changeLoading(false);
      this.arquivos = arquivos;
    });
  }

  getLicitacoesByFilter(isPaginationEvent: boolean) {
    this.orderDataSaved = true;
    this.loadingService.changeLoading(true);
    this.licitacaoService.getLicitacoesByFilter(this.licitacaoFilter, this.ultimoDadoPaginacao)
      .subscribe(result => {
        this.licitacoes = result;
        this.order = 'dataDeRealizacao';
        this.loadingService.changeLoading(false);
      }, error => {
        this.loadingService.changeLoading(false);
      });

    if (!isPaginationEvent) {
      this.licitacaoService.getTotalEntidades(this.licitacaoFilter).subscribe((total) => {
        const configuracaoPaginacao = new ConfiguracaoPaginacao();
        configuracaoPaginacao.totalPaginas = total;
        configuracaoPaginacao.paginaAtual = 0;

        this.subjectPaginacao.next(configuracaoPaginacao);
      });
    }
  }

  download(arquivo: Arquivo) {
    this.loadingService.changeLoading(true);
    window.open(arquivo.valor);
  }

  goToEditLicitacao(idLicitacao: number) {
    this.router.navigate([`/dashboard/licitacao/edit/${idLicitacao}`]);
  }

  copyLicitacaoLink(licitacao: Licitacao) {
    const licitacaoLink = this.licitacaoService.generateLicitacaoPermanentLink(
      window.location.origin,
      licitacao
    );

    // Verifica se o browser suporta a API de clipboard
    if (window.navigator && window.navigator['clipboard'] && typeof window.navigator['clipboard'].writeText === 'function') {
      window.navigator['clipboard'].writeText(licitacaoLink)
        .then(() => {
          this.openDialog('Link copiado para sua Área de Transferencia.', 'Link copiado!')
        })
        .catch((error) => {
          this.openDialog(`Link: ${licitacaoLink}`, 'Não foi possível copiar!');
          console.error('Error copying to clipboard: ', error);
        });
    } else {
      this.openDialog(`Link: ${licitacaoLink}`, 'Não foi possível copiar!');
      console.error('Clipboard API is not available in this browser.');
    }
  }

  private openDialog(content: string, title: string) {
    this.dialog.open(DialogComponent, {
      width: 'auto',
      data: { content, title },
    });
  }

  private generateLink(arquivo: Arquivo) {
    const dataURI = 'data:' + 'application/octet-stream;charset=utf8' +
      ';base64,' + arquivo.valor;
    return dataURI;
  }

  private searchRefer(list: any[], name) {
    let label = '';
    list.forEach(v => {
      if (v.value === name) {
        label = v.label;
      }
    });
    return label;
  }

  private sortByNumeroLicitacao(a, b) {
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }

    return 0;
  }

  onPaginationChange(eventoPaginacao: DadosPaginacao) {
    this.ultimoDadoPaginacao = eventoPaginacao;
    this.getLicitacoesByFilter(true);
  }

  exportar(tipoExportacao: string) {

    const downloadFnc = uri => {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = uri;
      a.download = 'olah';
      a.click();
      a.remove();
    }

    const uri = this.licitacaoService.getExportarURI(tipoExportacao, this.licitacaoFilter, this.ultimoDadoPaginacao);
    downloadFnc(uri);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/licitacao-list-simple/licitacao-list-simple.component.ts